// extracted by mini-css-extract-plugin
module.exports = {"Container":"📚4-7-02s40O","Blade":"📚4-7-02P8eQ"};